import { destructureAxiosReq } from '../services/utils';
import sureAxios from '../services/sureAxios';

/**
 * Get broker information.
 *
 * @param {String} brokerId The broker id.
 */
export function getBroker(brokerId) {
  return destructureAxiosReq(
    sureAxios.get(`/api/management/v1/brokers/${brokerId}`)
  );
}

/**
 * Get brokerages information.
 *
 * @param {String} brokerageSlug The brokerage slug or brokerage id.
 */
export function getBrokerage(brokerageSlug) {
  delete sureAxios.defaults.headers['Authorization'];
  return destructureAxiosReq(
    sureAxios.get(`/api/management/v1/brokerages/${brokerageSlug}`)
  );
}
